<script>
  export let mobile = false;
  export let currentStep = 'first';
</script>

<style lang="scss">
  .header-container.mobile {
  }
  .header-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    text-align: center;
    &.fifth {
      padding-left: 41px;
      padding-right: 41px;
    }
    .header {
      color: #6f6f6f;
      text-align: center;
      font-family: 'National 2 Narrow';
      font-size: 42px;
      font-style: normal;
      font-weight: 800;
      line-height: 38px; /* 90.476% */
      letter-spacing: -0.5px;
      text-transform: uppercase;
    }
    .description {
      color: #aaa;
      text-align: center;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      .bold {
        color: #1c1c1c;
      }
    }
    .gradient-text {
      background: linear-gradient(90deg, #4daeff 0%, #8f9afd 19%, #cba0f6 41%, #e9a8b1 58%, #fbb647 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      text-transform: uppercase;
    }
  }
</style>

<div>
  <div class="header-container {currentStep} {mobile ? 'mobile' : ''}">
    <div class="header">
      {#if currentStep === 'first'}
        Want Benable to grow your <span class="gradient-text">reach?</span>
      {/if}
      {#if currentStep === 'second'}
        Keep adding <span class="gradient-text">recs</span>
      {/if}
      {#if currentStep === 'third'}
        How WILL YOU know when the algorithm <span class="gradient-text">LOVES</span> YOUR LIST?
      {/if}
      {#if currentStep === 'fourth'}
        When YOUR LIST IS <span class="gradient-text">OPTIMIZED</span>, IT’S pushed out everywhere!
      {/if}
      {#if currentStep === 'fifth'}
        WITH a few Optimized lists, your profile will <span class="gradient-text">TREND</span> too
      {/if}
      {#if currentStep === 'sixth'}
        That’s it! Now get your first <span class="gradient-text">Optimized List</span>
      {/if}
    </div>
    <div class="description">
      {#if currentStep === 'first'}
        Increase your visibility and get more people discovering your recs
      {/if}
      {#if currentStep === 'second'}
        The better your lists are the more we’ll make them trend
      {/if}

      {#if currentStep === 'third'}
        You’ll see the <span class="bold">Optimized Badge! </span>
      {/if}
      {#if currentStep === 'fifth'}
        And get indexed on search engines!
      {/if}

      {#if currentStep === 'sixth'}
        Remember, you can create lists of anything you love
      {/if}
    </div>
  </div>
</div>
